import { useEffect } from 'react' //useState
import { Link } from 'react-router';
import { auth } from '../../db/auth';
import Logo from './logo.png';

export default function Header() {

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(userAuth => {
            // saveUser(userAuth);
        })
        return unsubscribe;
        // eslint-disable-next-line
    }, [])


    return (<>
      {/* HEADER */}
      <header style={{
        background:"linear-gradient(118deg,#7B0D1E 0%,#C0202D 55%,#E8384F 100%)",
        height:60, display:"flex", alignItems:"center", justifyContent:"space-between",
        padding:"0 16px", position:"sticky", top:0, zIndex:200,
        boxShadow:"0 4px 24px rgba(180,10,30,0.4)",
      }}>
        <div style={{ display:"flex", alignItems:"center", gap:10 }}>
          <div style={{
            width:38, height:38, borderRadius:11,
            background:"rgba(255,255,255,0.18)",
            border:"1.5px solid rgba(255,255,255,0.35)",
            display:"flex", alignItems:"center", justifyContent:"center", fontSize:19,
          }}>
            <img src={Logo} className='mx-2 rounded-circle' width={30} height={30} alt='logo' />
          </div>
          <div>
            <Link to="/"><div style={{ color:"#fff", fontWeight:900, fontSize:16, textAlign:'left' }}>All In One</div></Link>
            <div style={{ color:"rgba(255,255,255,0.6)", fontSize:8.5, letterSpacing:1.8, fontWeight:700 }}>YOUR LOCAL GUIDE</div>
          </div>
        </div>
        {/* <div style={{ position:"relative", cursor:"pointer" }}>
          <div style={{
            width:38, height:38, borderRadius:11,
            background:"rgba(255,255,255,0.14)",
            border:"1px solid rgba(255,255,255,0.25)",
            display:"flex", alignItems:"center", justifyContent:"center", fontSize:19,
          }}>🛒</div>
          <div style={{
            position:"absolute", top:-5, right:-5,
            width:17, height:17, borderRadius:"50%",
            background:"#FFD700", display:"flex", alignItems:"center", justifyContent:"center",
            fontSize:9, fontWeight:900, color:"#7B0D1E",
          }}>1</div>
        </div> */}
      </header>
      </>
    )
}
